module.exports = __webpack_public_path__ + "static/rad3-a075ad76860bac7aa0342541045dfe1d.jpg";